<template>
  <div class="bottom-bar">
    <div class="bottom-bar__main">
      <router-link 
        class="bottom-bar__home touch"
        tag="button"
        to="/select"
      ><fa icon="home-lg-alt"/></router-link>      
      <div v-if="showPropertyTypes" class="bottom-bar__nav-items">
        <div
          v-for="item in navigationItems"
          class="bottom-bar__nav-item-wrapper"
          :class="{ 'bottom-bar__nav-item-wrapper--active': isNavItemActive(item) }"
          :key="item._id"
        >
          <div class="bottom-bar__nav-item-line"></div>
          <router-link 
            class="bottom-bar__nav-item touch"
            :class="{ 'bottom-bar__nav-item--active': isNavItemActive(item) }"
            tag="button"
            :to="`/live/page/${item.pageId}`"
            @click.native="triggerVideo(item.videoWallTrigger)"
          >
            <span class="bottom-bar__nav-label" v-html="item.label"></span>
          </router-link>
        </div>        
        <div
          class="bottom-bar__nav-item-wrapper"
          :class="{ 'bottom-bar__nav-item-wrapper--active': isPropertyTypeActive(null) }"
        >
          <div class="bottom-bar__nav-item-line"></div>
          <button 
            class="bottom-bar__nav-item touch"
            :class="{ 'bottom-bar__nav-item--active': isPropertyTypeActive(null) }"
            @click="setInputPropertyType(null)"
          >
            {{ language.code  === 'en' ? 'Masterplan' : 'المخطط العام' }}
          </button>
        </div>
        <div
          v-for="propertyType in propertyTypes" :key="propertyType"
          class="bottom-bar__nav-item-wrapper"
          :class="{ 'bottom-bar__nav-item-wrapper--active': isPropertyTypeActive(propertyType) }"
        >
          <div class="bottom-bar__nav-item-line"></div>
          <button 
            class="bottom-bar__nav-item touch"
            :class="{ 'bottom-bar__nav-item--active': isPropertyTypeActive(propertyType) }"
            @click="setInputPropertyType(propertyType)"
          >
            {{ 
              language.code === 'en' ? propertyType + 's' : 
              propertyType === 'apartment' ? 'الشقق' : 
              propertyType === 'villa' ? 'الفلل' : 
              propertyType === 'townhome' ? 'المنازل المدمجة' : 
              propertyType === 'palace' ? 'القصور' : '' }}
          </button>
        </div>
        <div class="bottom-bar__nav-item-line"></div>
      </div>
      <div v-if="!showPropertyTypes && navigationItems" class="bottom-bar__nav-items" :class="{ 'dir-rtl' : language.rtl }">
        <div
          v-for="item in navigationItems"
          class="bottom-bar__nav-item-wrapper"
          :class="{ 'bottom-bar__nav-item-wrapper--active': isNavItemActive(item) }"
          :key="item._id"
        >
          <div class="bottom-bar__nav-item-line"></div>
          <router-link 
            class="bottom-bar__nav-item touch"
            :class="{ 'bottom-bar__nav-item--active': isNavItemActive(item) }"
            tag="button"
            :to="`/category/${$store.state.route.params.categoryId}/page/${item.pageId}`"
            @click.native="triggerVideo(item.videoWallTrigger)"
          >
            <span class="bottom-bar__nav-label" v-html="item.label[language.code]"></span>
          </router-link>
        </div>
        <div class="bottom-bar__nav-item-line"></div>
      </div>
      <div class="language-selector" v-if="languages.length > 1">
        <span 
          v-for="lang in languages"
          :key="lang.code"
          class="language-selector__btn"
          :class="lang.code === language.code ? 'active' : null"
          @click="setLanguage(lang.code)"
        >
          {{ lang.code }}
        </span>
      </div>
      <router-link to="/" tag="span" class="touch"><img class="bottom-bar__sensoreal-logo" src="/assets/sensoreal.png"><span class="bottom-bar__version">{{ $store.state.version }}</span></router-link>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  // props: ['navigation-items'],
  
  computed: {
    ...mapGetters({
      activePage: 'activePage',
      language: 'language',
      propertyTypes: 'property/propertyTypes'
    }),

    showPropertyTypes () {
      return this.$route.path.includes('live')
    },

    navigationItems () {
      return this.$store.getters.activeNavigation
      // return _.sortBy(this.$store.getters.activeNavigation, item => item.order)
    },

    language () {
      return this.$store.getters.language
    },

    languages () {
      return this.$store.getters.languages
    }
  },

  methods: {
    ...mapActions([
      'triggerVideo'
    ]),

    isNavItemActive (item) {
      return this.activePage && (item.pageId === this.activePage._id || _.find(item.children, child => {
        return child.pageId === this.activePage._id
      }))
    },

    isPropertyTypeActive (propertyType) {
      return !this.$route.path.includes('/page') && propertyType === this.$store.state.property.inputType
    },

    setInputPropertyType (propertyType) {
      this.$store.commit('property/RESET_FILTER_PARAMETERS')
      this.$store.commit('property/SET_FILTER_PARAMETERS', { inputType: propertyType })
      this.$router.push('/live')
    },

    setLanguage (languageCode) {
      // TODO get available languages from store / match and commit
      const selectedLanguage = _.find(this.languages, lang => {
        return lang.code === languageCode
      })

      this.$store.commit('SET_LANGUAGE', selectedLanguage)
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";

.bottom-bar {
  bottom: 0;
  left: 0;
  display: flex;
  position: absolute;
  width: 100%;

  &__main {
    align-items: center;
    background-color: $dblue; //$bottombar-bg-color;
    bottom: 0;
    display: flex;
    flex-grow: 1;
    height: 8rem;
    justify-content: center;
    padding: 0 6rem 0 5rem;
  }

  &__home {
    font-size: 2.5rem;
  }

  &__nav-items {
    display: flex;
    flex-grow: 1;
    height: 100%;
    justify-content: flex-start;
    padding-left: 1.8rem;
  }

  &__nav-item-wrapper {
    display: flex;
  }

  &__nav-item-line {
    align-self: center;
    background-color: $bottombar-text-color;
    height: 50%;
    width: 1px;
    transition: background-color 0.3s;

    .bottom-bar__nav-item-wrapper--active & {
      // background-color: $bottombar-text-color-active;
    }
  }

  &__nav-item {
    // border-left: 1px solid $bottombar-text-color;
    font-family: 'Nexa';
    font-size: 1.5rem;
    font-weight: 200;
    height: 100%;
    letter-spacing: 0.15rem;
    padding: 0rem 3rem 0rem;
    text-transform: uppercase;    
    transition: padding-bottom 0.3s, color 0.3s;

    .ar & {
      font-family: 'GE Dinkum';
    }    

    &.router-link-active, &--active {
      // padding-bottom: 1.5em;
      color: $gold; // $bottombar-text-color-active;
    }
  }

  &__sensoreal-logo {
    justify-self: flex-end;
    width: 9rem;
  }

  &__version {
    color: rgba(255, 255, 255, 0.25);
    display: block;
    text-align: right;
  }
}

.language-selector {
  display: flex;
  font-family: 'Nexa';
  font-size: 2rem;
  margin: 0 4rem;
  z-index: 1000;

  &__btn {
    color: #666;
    padding: .5em;
    text-transform: uppercase;

    &.active {
      color: $gold; //$bottombar-text-color-active;
      opacity: 1;
    }

    &::after {
      background: $bottombar-text-color;
      content: '';
      height: 1em;
      margin: 0 .5em;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
    }

    &:last-child::after {
      content: none;
    }
  }
}
</style>
